var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"TXT-fCnl2pH-jCB2t11-h"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["lamudi-nextjs@dubizzlelab"]={id:"TXT-fCnl2pH-jCB2t11-h"};
      